export default {
  // Navbar
  "nav.home": "Startseite",
  "nav.shoppingGuide": "Einkaufsführer",
  "nav.spreadsheet": "CSSBuy Spreadsheet",
  "nav.categories": "Kategorien",
  "nav.guides": "Leitfäden",
  "nav.qc": "QC",
  "nav.shipping": "Versand",
  "nav.comparisons": "Vergleiche",
  "nav.safety": "Sicherheit",
  "nav.language": "Sprache",
  "nav.search": "Suchen",
  "nav.cta": "Spreadsheet erkunden",

  // Hero
  "hero.eyebrow": "CSSBUY GUIDE • SPREADSHEET • EINKAUF",
  "hero.h1": "CSSBuy Spreadsheet: Produkte, Verkäufer & Kaufanleitungen finden",
  "hero.description": "Erkunden Sie das CSSBuy Spreadsheet, entdecken Sie Produkte und Verkäufer, vergleichen Sie Optionen und lernen Sie, wie Sie QC, Lagerung, Versand und wichtige Informationen vor dem Kauf bewerten.",
  "hero.cta.primary": "CSSBuy Spreadsheet erkunden",
  "hero.cta.secondary": "Kaufanleitungen ansehen",
  "hero.trust": "Informative Inhalte • Aktualisierte Leitfäden • Transparente Vergleiche",

  // Search
  "search.h2": "Schnell im CSSBuy Spreadsheet finden",
  "search.placeholder": "Produkte, Kategorien oder Verkäufer suchen...",
  "search.filters": "Kategorie / Produkt / Verkäufer / QC / Beliebtheit / Neueste",
  "search.button": "Suchen",

  // Benefits
  "benefits.h2": "Alles, was Sie zum Verstehen des CSSBuy Spreadsheet brauchen",
  "benefits.findProducts": "Produkte finden",
  "benefits.findProductsDesc": "Entdecken Sie, wie Sie Produkte recherchieren und relevante Informationen organisieren.",
  "benefits.compareSellers": "Verkäufer vergleichen",
  "benefits.compareSellersDesc": "Lernen Sie, welche Faktoren Sie vor der Wahl eines Verkäufers analysieren sollten.",
  "benefits.checkQC": "QC prüfen",
  "benefits.checkQCDesc": "Verstehen Sie, wie Sie Qualitätskontrollfotos interpretieren.",
  "benefits.understandShipping": "Versand verstehen",
  "benefits.understandShippingDesc": "Lernen Sie die wichtigsten Faktoren kennen, die Versandkosten und -methoden beeinflussen.",

  // Spreadsheet Hub
  "spreadsheet.h2": "CSSBuy Spreadsheet",
  "spreadsheet.text": "Unser CSSBuy Spreadsheet-Hub bündelt Ressourcen nach Kategorien, um die Recherche nach Produkten, Verkäufern und Leitfäden zu erleichtern.",
  "spreadsheet.cta": "Spreadsheet erkunden",

  // Categories
  "categories.h2": "Beliebte Kategorien",
  "categories.viewAll": "Alle Kategorien ansehen",
  "categories.shoes": "Sneaker",
  "categories.hoodies": "Streetwear",
  "categories.tshirts": "T-Shirts",
  "categories.sweaters": "Hoodies",
  "categories.jackets": "Jacken",
  "categories.pants": "Hosen",
  "categories.bags": "Taschen",
  "categories.accessories": "Accessoires",
  "categories.sportswear": "Sportbekleidung",

  // How It Works
  "howItWorks.h2": "Wie nutzt man ein CSSBuy Spreadsheet?",
  "howItWorks.step1": "Recherchieren",
  "howItWorks.step1Desc": "Produkte, Kategorien oder Verkäufer finden.",
  "howItWorks.step2": "Analysieren",
  "howItWorks.step2Desc": "Verfügbare Informationen und Daten prüfen.",
  "howItWorks.step3": "Vergleichen",
  "howItWorks.step3Desc": "Verschiedene Optionen bewerten.",
  "howItWorks.step4": "Überprüfen",
  "howItWorks.step4Desc": "QC, Versand, Lagerung und Sicherheit prüfen.",
  "howItWorks.step5": "Fortfahren",
  "howItWorks.step5Desc": "Bei Bedarf zur Hauptwebsite weiterleiten.",

  // Guides
  "guides.h2": "Leitfäden für besser informiertes Einkaufen",
  "guides.viewAll": "Alle Leitfäden ansehen",
  "guides.review": "CSSBuy Review",
  "guides.shipping": "CSSBuy Shipping Cost",
  "guides.warehouse": "CSSBuy Warehouse",
  "guides.legit": "CSSBuy Legit",
  "guides.coupon": "CSSBuy Coupon",
  "guides.discount": "CSSBuy Discount Code",

  // Comparison
  "comparison.h2": "Vor der Auswahl vergleichen",
  "comparison.viewAll": "Vergleiche ansehen",

  // Safety
  "safety.h2": "Sicherheit geht vor",
  "safety.text": "Lernen Sie, wie Sie Links, Verkäufer, Produkte, QC, Zahlungen und Informationen vor dem Kauf überprüfen.",
  "safety.cta": "Sicherheitszentrum öffnen",

  // Trust
  "trust.h2": "Transparente und unabhängige Inhalte",
  "trust.text": "CSSBuyBR.INK ist eine unabhängige Ressource zur Organisation von Informationen, Leitfäden und Ressourcen rund um das CSSBuy Spreadsheet. Wir sind nicht die offizielle CSSBuy-Website, sofern nicht ausdrücklich und nachweisbar angegeben.",

  // Final CTA
  "finalCta.h2": "Bereit, das CSSBuy Spreadsheet zu erkunden?",
  "finalCta.text": "Finden Sie Ressourcen, vergleichen Sie Informationen und wählen Sie den richtigen Leitfaden für Ihren nächsten Schritt.",
  "finalCta.primary": "CSSBuy Spreadsheet erkunden",
  "finalCta.secondary": "Hauptwebsite besuchen",

  // Category Dropdown
  "dropdown.title": "Produktkategorien",
  "dropdown.shoes": "Shoes",
  "dropdown.hoodies": "Hoodies/Sweaters",
  "dropdown.tshirts": "T-Shirts",
  "dropdown.jackets": "Jackets",
  "dropdown.pants": "Pants/Shorts",
  "dropdown.headwear": "Headwear",
  "dropdown.sets": "Sets",
  "dropdown.underwear": "Underwear/Underpants",
  "dropdown.jersey": "Jersey",
  "dropdown.accessories": "Accessories",
  "dropdown.bags": "Bags",
  "dropdown.belts": "Belts",
  "dropdown.perfumes": "Perfumes",
  "dropdown.other": "Other Stuff",

  // Buttons
  "button.cssbuySpreadsheet": "CSSBuy Spreadsheet",
  "button.buyItNow": "Buy It Now",

  // Footer
  "footer.about": "Über uns",
  "footer.editorial": "Redaktionsrichtlinien",
  "footer.contact": "Kontakt",
  "footer.privacy": "Datenschutz",
  "footer.terms": "Nutzungsbedingungen",
  "footer.disclaimer": "Haftungsausschluss",
  "footer.disclaimerText": "CSSBuyBR.INK ist eine unabhängige Informationsressource. Wir sind nicht die offizielle CSSBuy-Website. Überprüfen Sie wichtige Informationen vor dem Kauf immer anhand offizieller Quellen.",
  "footer.copyright": "© 2026 CSSBuyBR.INK — Unabhängige CSSBuy Spreadsheet Ressource",

  // Articles
  "articles.h2": "Artikel & Leitfäden",
  "articles.readMore": "Vollständigen Artikel lesen",
  "articles.backToHome": "Zurück zur Startseite",
  "articles.relatedArticles": "Verwandte Artikel",
  "articles.updated": "Aktualisiert am",
  "articles.published": "Veröffentlicht am",
  "articles.author": "Autor",
  "articles.minRead": "Min. Lesezeit",
  "articles.keyTopics": "Wichtige Themen",
  "articles.fullContentSoon": "Der vollständige Inhalt dieses Leitfadens wird vorbereitet. Unten finden Sie eine Zusammenfassung der wichtigsten Themen.",

  // Language Switcher
  "lang.pt": "Português",
  "lang.en": "English",
  "lang.de": "Deutsch",

  // NotFound
  "notFound.title": "Seite nicht gefunden",
  "notFound.description": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
  "notFound.backHome": "Zurück zur Startseite",
};